import React, {useEffect, useState} from 'react';
import {Button, Text, TextField} from '@cloudaper/react';
import AppHeader from '../AppHeader';

const Finalize = props => {
  const {
    validateRouteToken,
    handleUpdateRoom,
    handleRedirectToDm,
    validateEmail,
  } = props;

  useEffect(() => {
    document.title = 'Firemní údaje - Začněte s Document Managerem';

    validateRouteToken('welcome');
  }, [validateRouteToken]);

  const [firma, setFirma] = useState('');
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [ulice, setUlice] = useState('');
  const [uliceError, setUliceError] = useState(false);
  const [mesto, setMesto] = useState('');
  const [mestoError, setMestoError] = useState(false);
  const [psc, setPsc] = useState('');
  const [pscError, setPscError] = useState(false);
  const [ic, setIc] = useState('');
  const [icError, setIcError] = useState(false);
  const [dic, setDic] = useState('');

  const [skipping, setSkipping] = useState(false);
  const [processing, setProcessing] = useState(false);

  return (
    <>
      <AppHeader />

      <div className="appWrapper">
        <div className="appContent appContentMedium" style={{display: "none"}}>
          <Text className="appHeading centeredText">Dokončete registraci</Text>
          <br />
          <Text className="centeredText cardBodyText">
            Vyplňte prosím údaje subjektu, pro který Document Manager nastavujete.
            Pokud se vám to nyní nehodí, můžete vyplnění přeskočit,
            a my vás kontaktujeme, až je budeme potřebovat.
          </Text>

          <br />
          <div className="routeGrid">
            <TextField
              disabled={skipping || processing}
              helper
              handleEnter={() => {}}
              label="Název firmy (nepovinné)"
              onChange={e => setFirma(e.target.value)}
              value={firma}
              id="dm-onboarding-welcome-2-3"
            />

            <TextField
              disabled={skipping || processing}
              helper
              handleEnter={() => {}}
              label="E-mail pro zasílání faktur"
              onChange={e => setEmail(e.target.value)}
              value={email}
              id="dm-onboarding-welcome-2-4"
              onFocus={() => setEmailError(false)}
              onBlur={() => setEmailError(true)}
              error={
                emailError &&
                ((email && !validateEmail(email) && 'Nesprávný email') ||
                  (!email && 'Vyplňte pole'))
              }
            />

            <TextField
              disabled={skipping || processing}
              helper
              handleEnter={() => {}}
              label="Ulice a číslo popisné"
              onChange={e => setUlice(e.target.value)}
              value={ulice}
              id="dm-onboarding-welcome-2-5"
              onFocus={() => setUliceError(false)}
              onBlur={() => setUliceError(true)}
              error={uliceError && !ulice && 'Vyplňte pole'}
            />

            <TextField
              disabled={skipping || processing}
              helper
              handleEnter={() => {}}
              label="Město"
              onChange={e => setMesto(e.target.value)}
              value={mesto}
              id="dm-onboarding-welcome-2-6"
              onFocus={() => setMestoError(false)}
              onBlur={() => setMestoError(true)}
              error={mestoError && !mesto && 'Vyplňte pole'}
            />

            <TextField
              disabled={skipping || processing}
              helper
              handleEnter={() => {}}
              label="PSČ"
              onChange={e => setPsc(e.target.value)}
              value={psc}
              id="dm-onboarding-welcome-2-7"
              onFocus={() => setPscError(false)}
              onBlur={() => setPscError(true)}
              error={pscError && !psc && 'Vyplňte pole'}
            />

            <div className="routeGrid">
              <TextField
                disabled={skipping || processing}
                helper
                handleEnter={() => {}}
                label="IČ"
                onChange={e => setIc(e.target.value)}
                value={ic}
                id="dm-onboarding-welcome-2-8"
                onFocus={() => setIcError(false)}
                onBlur={() => setIcError(true)}
                error={icError && !ic && 'Vyplňte pole'}
              />

              <TextField
                disabled={skipping || processing}
                helper
                handleEnter={() => {}}
                label="DIČ (nepovinné)"
                onChange={e => setDic(e.target.value)}
                value={dic}
                id="dm-onboarding-welcome-2-9"
              />
            </div>
          </div>

          <div className="routeButtons">
            <Button
              disabled={
                skipping ||
                processing ||
                !email ||
                !validateEmail(email) ||
                !ulice ||
                !mesto ||
                !psc ||
                !ic
              }
              kind="primary"
              onClick={async () => {
                setProcessing(true);
                const status = await handleUpdateRoom(
                  firma || undefined,
                  email,
                  ulice,
                  mesto,
                  psc,
                  ic,
                  dic || undefined,
                );
                if (status === 200) {
                  handleRedirectToDm();
                }
              }}
              raised
            >
              {processing ? 'Zpracovávám' : 'Potvrdit'}
            </Button>

            <Button
              disabled={skipping || processing}
              onClick={() => {
                setSkipping(true);
                handleRedirectToDm();
              }}
              raised
            >
              Přeskočit
            </Button>
          </div>
        </div>

        <div className="appContent appContentMedium">
          <Text className="appHeading centeredText">Hotovo!</Text>
          <br />
          <Text className="centeredText cardBodyText">
            Můžete pokračovat do Document Manageru. Kdybyste cokoliv potřebovali,
            neváhejte nás kontaktovat. My se vám během pár dní ozveme ozveme
            a doladíme společně nastavení, smlouvu a platbu.
          </Text>

          <div className="routeButtons">
            <Button
              disabled={skipping || processing}
              onClick={() => {
                setSkipping(true);
                handleRedirectToDm();
              }}
              raised
            >
              Pokračovat do Document Manageru
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Finalize;
